import React, { forwardRef } from 'react';

/**
 * Componente de campo de texto avançado
 * Suporta multiline, fullWidth e outros recursos
 * 
 * @param {Object} props - Propriedades do componente
 * @param {string} [props.label] - Label do campo
 * @param {boolean} [props.multiline=false] - Se o campo deve ser multiline (textarea)
 * @param {number} [props.rows=4] - Número de linhas para textarea
 * @param {boolean} [props.fullWidth=false] - Se deve ocupar toda a largura disponível
 * @param {string} [props.className] - Classes adicionais
 * @param {boolean} [props.disabled] - Se o campo está desabilitado
 * @returns {JSX.Element} Componente React
 */
const TextField = forwardRef(({ 
  label, 
  multiline = false,
  rows = 4,
  fullWidth = false,
  className = '',
  disabled = false,
  ...props 
}, ref) => {
  const baseClasses = `
    px-3 py-2 border border-gray-300 rounded-md shadow-sm
    focus:outline-none focus:ring-blue-500 focus:border-blue-500
    ${disabled ? 'bg-gray-100 cursor-not-allowed' : ''}
    ${fullWidth ? 'w-full' : ''}
    ${className}
  `;

  return (
    <div className={fullWidth ? 'w-full' : ''}>
      {label && (
        <label className="block text-sm font-medium text-gray-700 mb-1">
          {label}
        </label>
      )}
      
      {multiline ? (
        <textarea
          ref={ref}
          rows={rows}
          disabled={disabled}
          className={baseClasses}
          {...props}
        />
      ) : (
        <input
          ref={ref}
          type="text"
          disabled={disabled}
          className={baseClasses}
          {...props}
        />
      )}
    </div>
  );
});

TextField.displayName = 'TextField';

export default TextField; 